var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "productLeftBottomTagMain" },
    [
      _vm.transportationDescriptionList
        ? _vm._l(_vm.transportationDescriptionList, function(
            transportationDescription,
            index
          ) {
            return _c("div", { key: index, staticClass: "tag" }, [
              _vm._v(
                "\n            " +
                  _vm._s(transportationDescription) +
                  "\n        "
              )
            ])
          })
        : _vm.distance
        ? _c("div", { staticClass: "tag" }, [_vm._v("\n        次日达\n    ")])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }